<template>
  <div class="group relative overflow-hidden rounded-2xl bg-gray-800 border border-gold-800 hover:border-gold-600 transition-all duration-500 hover:shadow-2xl hover:shadow-gold-900/30">
    <img 
      :src="item.image" 
      :alt="item.title"
      class="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-500"
    >
    <div class="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-end">
      <div class="p-6 text-center w-full">
        <h3 class="text-2xl font-display font-bold text-gold-400 mb-2">{{ item.title }}</h3>
      </div>
    </div>
    <div class="absolute top-4 left-4 bg-gold-700 text-gray-900 px-4 py-1 rounded-full text-sm font-semibold">
      {{ item.tag }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'GalleryItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>